// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-wrapper {
  height: 27px;
}
.bg-wrapper .bg {
  background-image: url("/assets/eintracht/bg.png");
  background-repeat: repeat-x;
}
.bg-wrapper .bg.mirror {
  transform: scaleX(-1);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/sub-header-line/sub-header-line.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AAAE;EACE,iDAAA;EACA,2BAAA;AAEJ;AADI;EACE,qBAAA;AAGN","sourcesContent":[".bg-wrapper {\n  height: 27px;\n  .bg {\n    background-image: url(\"/assets/eintracht/bg.png\");\n    background-repeat: repeat-x;\n    &.mirror{\n      transform: scaleX(-1);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
